import React, { useState } from 'react';
import "./header.css";
import logoMgSUL from "../../imagens/logos/logoMgSUL.png";
import bandeiraBrasil from "../../imagens/flags/bandeiraBrasil.png";
import bandeiraEUA from "../../imagens/flags/bandeiraEUA.png";
import { Link, useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import { useTranslation } from "react-i18next";
  
function Header() {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleOffcanvasClose = () => setShowOffcanvas(false);
  const handleOffcanvasShow = () => setShowOffcanvas(true);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);
    handleOffcanvasClose();
  };

  const handleNavClick = (path) => {
    handleOffcanvasClose();
    navigate(path);
  };

  const navItems = [
    { path: "/", title: t("Início") },
    {
      title: t("Empresa"),
      isDropdown: true,
      items: [
        { path: "/AboutUs", title: t("Sobre nós") },
        { divider: true },
        { path: "/?scroll=meioambiente", title: t("Sustentabilidade e meio ambiente") },
      ],
    },
    { path: "/Capabilities/Production", title: t("Competências") },
    {
      title: t("Contato"),
      isDropdown: true,
      items: [
        { path: "/ContactUs", title: t("Fale Conosco") },
        { divider: true },
        { path: "/Denuncia", title: t("Canal de denúncias") },
      ],
    },
    { path: "/?scroll=certificados", title: t("Certificados") },
    { path: "/Customers", title: t("Clientes") },
  ];

  const renderNavItems = (isOffcanvas = false) =>
    navItems.map((item) => {
      if (item.isDropdown) {
        return (
          <NavDropdown
            title={item.title}
            key={item.title}
            className={`custom-nav-link ${isOffcanvas ? "py-1 w-100" : ""}`}
          >
            {item.items.map((subItem, subIndex) =>
              subItem.divider ? (
                <NavDropdown.Divider key={`divider-${subIndex}`} />
              ) : (
                <NavDropdown.Item
                  key={subItem.path}
                  onClick={() => handleNavClick(subItem.path)}
                  className="custom-nav-link-dropdown w-100"
                >
                  {subItem.title}
                </NavDropdown.Item>
              )
            )}
          </NavDropdown>
        );
      }

      return (
        <Nav.Link
          key={item.path}
          onClick={() => handleNavClick(item.path)}
          className={`custom-nav-link ${isOffcanvas ? "py-1 w-100" : ""}`}
        >
          {item.title}
        </Nav.Link>
      );
    });

  return (
    <header className="p-0 shadow-sm top-0" style={{ zIndex: 800, backgroundColor: "#f4f4f4" }}>
      <Navbar expand="lg" variant="light" className="w-100">
        <Container fluid className="px-3 d-flex align-items-center justify-content-between header-container">

          {/* TOGGLER (mobile) */}
          <Button
            variant="link"
            onClick={handleOffcanvasShow}
            className="d-lg-none p-0 border-0 navbar-toggler-custom"
            aria-controls="offcanvasNavbar"
            aria-label="Toggle navigation"
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>

          {/* LOGO (central visual) */}
          <Navbar.Brand as={Link} to="/" className="LogoImage logo-container">
            <img src={logoMgSUL} alt="Logo MGSUL" />
          </Navbar.Brand>

          {/* Nav (desktop) - oculto automaticamente em mobile */}
          <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-center">
            <Nav className="mx-auto">{renderNavItems(false)}</Nav>
          </Navbar.Collapse>

          {/* BANDEIRAS (sempre visíveis; alinhadas em linha) */}
          <Nav className="flag-nav">
            <Button variant="link" onClick={() => handleLanguageChange("pt")} className="flag-button">
              <Image src={bandeiraBrasil} alt="Português" className="flag-icon" />
            </Button>
            <Button variant="link" onClick={() => handleLanguageChange("en")} className="flag-button">
              <Image src={bandeiraEUA} alt="Inglês" className="flag-icon" />
            </Button>
          </Nav>
        </Container>
      </Navbar>

      {/* OFFCANVAS para menu mobile */}
      <Offcanvas
        show={showOffcanvas}
        onHide={handleOffcanvasClose}
        placement="start"
        id="offcanvasNavbar"
        aria-labelledby="offcanvasNavbarLabel"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title id="offcanvasNavbarLabel" className="title">
            {t("Menu")}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0 d-flex flex-column">
          <Nav className="flex-column">{renderNavItems(true)}</Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </header>
  );
}

export default Header;
